import { HubJsonRpcRequest } from '../api/HubJsonRpcRequest';
import { HubApiMethods } from '../constants/HubApiMethods';
import { GetTimeResponse } from '../api/hub-responses/get-time-response';

export class ServerTime {
    private diff: number|null = null;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private syncInProgress: Promise<any>;

    public async getTime(): Promise<number> {
        if (this.diff === null && !this.syncInProgress) {
            this.syncInProgress = this.getDiff();
            await this.syncInProgress;
        }

        if (this.syncInProgress) {
            await this.syncInProgress;
        }

        const diff = this.diff ? this.diff : 0;
        return Math.floor(Date.now() / 1000) + diff;
    }

    private async getDiff() {
        const requestStartTs = Math.floor(Date.now() / 1000);
        this.syncInProgress = HubJsonRpcRequest.makeRequest<GetTimeResponse, undefined>(
            HubApiMethods.GET_SERVER_TIME,
            undefined,
            window.app.deviceIdentifier
        );
        const serverTime = await this.syncInProgress
            .then((response) => {
                if (response?.time) {
                    return response.time;
                }

                return null;
            })
            .catch(()=>{
                return null;
            });
        this.syncInProgress = void 0;
        if (serverTime !== null) {
            this.diff = serverTime - requestStartTs;
        }
    }
}
